<div class="content-card filters">
  <div class="top">
    <div class="top__left">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <button mat-icon-button (click)="previousMonth()">
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <span class="date-label" (click)="picker.open()">
            {{ currentDate | date : 'MM.yyyy' }}
          </span>
          <button mat-icon-button (click)="nextMonth()">
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
          <div class="datepicker">
            <input matInput [matDatepicker]="picker" readonly />
            <mat-datepicker #picker startView="year" (monthSelected)="onDateChange($event, picker)"></mat-datepicker>
          </div>
          <button mat-icon-button (click)="picker.open()">
            <mat-icon>event</mat-icon>
          </button>
        </div>
      </div>
      <div class="mont-hours-container" *ngIf="monthWorkingTime$ | async as monthWorkingTime">
        <span>{{
          'PresencePerMonthList.MonthWorkingHours'
          | translate : { monthWorkingDays: monthWorkingTime.days, monthWorkingHours: monthWorkingTime.hours }
          }}</span>
      </div>
    </div>
    <div class="top__right">
      <mat-form-field *ngIf="showFilterPresetSelector" [@inOutAnimation] appearance="outline"
        class="filter-preset-selector">
        <mat-label>Filtr</mat-label>
        <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
          <ng-container *ngFor="let preset of filterPresets">
            <mat-option [value]="preset.Id">{{
              preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
              }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <button (click)="resetFilters()" class="top__button top__button-clear">
        <mat-icon>close</mat-icon>
        {{ 'Reset' | translate }}
      </button>
      <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
        <mat-icon>filter_alt</mat-icon>
        {{ 'Filter' | translate }}
      </button>
    </div>
  </div>
  <div #filterSection *ngIf="areFiltersExpanded">
    <app-presence-per-month-list-filters *ngIf="areFiltersExpanded" [formGroup]="filtersFormGroup"
      (filterGridData)="filterData($event)">
      <div class="favorite-button-row-container">
        <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
          <ng-container *ngIf="isSavedFilterPreset; then unsaveBtn; else saveBtn"></ng-container>
          <ng-template #saveBtn>
            <mat-icon>bookmark_border</mat-icon>
            {{ 'SaveFilter' | translate }}
          </ng-template>
          <ng-template #unsaveBtn>
            <mat-icon>bookmark</mat-icon>
            {{ 'UnsaveFilter' | translate }}
          </ng-template>
        </button>
      </div>
    </app-presence-per-month-list-filters>
  </div>
</div>

<div class="content-card">
  <div class="table-wrapper custom-table" [style.max-height]="listHeight">
    <mat-table #table matSort matSortActive="company" matSortDirection="desc" matSortDisableClear
      [dataSource]="dataSource.presences$ | async">
      <ng-container matColumnDef="workerFullName" [sticky]="screenService.isAboveMd$ | async">
        <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
          {{ 'PresencePerMonthList.WorkerFullName' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element"><a [routerLink]="['/profile', element.WorkerId, 'timesheets']"
            tabindex="-1">{{ element.LastName }} {{ element.FirstName }}</a></mat-cell>
      </ng-container>

      <ng-container matColumnDef="pesel">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Pesel' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.Pesel }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="company">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Company' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.Company" [matTooltipPosition]="'above'">{{
          element.Company }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="employerObject">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EmployerObject' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [matTooltip]="element.EmployerObject" [matTooltipPosition]="'above'">{{
          element.EmployerObject
          }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="employmentType">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'EmploymentType' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmploymentType }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employmentDateFrom">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.EmploymentDateFrom' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmploymentDateFrom | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="employmentDateTo">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.EmploymentDateTo' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmploymentDateTo | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalTimespan">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.TotalTimespan' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.TotalTimespan ? (element.TotalTimespan | ticksToString) : ''
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalTimespanDay">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.TotalTimespanDay' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.TotalTimespanDay ? (element.TotalTimespanDay | ticksToString) :
          '' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalTimespanNight">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.TotalTimespanNight' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.TotalTimespanNight ? (element.TotalTimespanNight | ticksToString)
          : '' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="workedDays">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.WorkedDays' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.WorkedDays ? element.WorkedDays : '' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="correctedTotalTimespan">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.CorrectedTotalTimespan' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.CorrectedTotalTimespan ? (element.CorrectedTotalTimespan |
          ticksToString) : '' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="correctedTotalTimespanDay">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.CorrectedTotalTimespanDay' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <ng-container *matCellDef="let element">
          <ng-container *ngIf="element.CanEditCorrection && hasPermissionToSetCorrections(); else label">
            <mat-cell class="input-cell" [matTooltip]="'PresencePerMonthList.ObsoleteInfo' | translate"
              matTooltipPosition="above" [matTooltipDisabled]="element.IsUpToDate">
              <input matInput #formControl="ngModel" class="time-correction-input" mask="separator.2"
                placeholder="___:__" [ngClass]="{
                  obsolete: !element.IsUpToDate,
                  modified: element.OriginCorrectedTotalTimespanDay !== undefined,
                  error: formControl.invalid
                }" [decimalMarker]="minutesSeparator" [inputTransformFn]="inputTransformFn"
                [outputTransformFn]="outputTransformFn" [ngModel]="element.CorrectedTotalTimespanDay"
                (ngModelChange)="saveTotalTimespanDayCorrection($event, element)" [required]="
                  (element.CorrectedTotalTimespanNight !== null && element.CorrectedTotalTimespanNight !== undefined) ||
                  (element.CorrectedWorkedDays !== null && element.CorrectedWorkedDays !== undefined)
                " (blur)="onBlurLeadZero(formControl)" type="text" />
            </mat-cell>
          </ng-container>
          <ng-template #label><mat-cell>{{ element.CorrectedTotalTimespanDay ? (element.CorrectedTotalTimespanDay |
              ticksToString) : '' }} </mat-cell></ng-template>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="correctedTotalTimespanNight">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.CorrectedTotalTimespanNight' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <ng-container *matCellDef="let element">
          <ng-container *ngIf="element.CanEditCorrection && hasPermissionToSetCorrections(); else label">
            <mat-cell class="input-cell" [matTooltip]="'PresencePerMonthList.ObsoleteInfo' | translate"
              matTooltipPosition="above" [matTooltipDisabled]="element.IsUpToDate">
              <input matInput #formControl="ngModel" class="time-correction-input" mask="separator.2"
                placeholder="___:__" [ngClass]="{
                  obsolete: !element.IsUpToDate,
                  modified: element.OriginCorrectedTotalTimespanNight !== undefined,
                  error: formControl.invalid
                }" [decimalMarker]="minutesSeparator" [inputTransformFn]="inputTransformFn"
                [outputTransformFn]="outputTransformFn" [ngModel]="element.CorrectedTotalTimespanNight"
                (ngModelChange)="saveTotalTimespanNightCorrection($event, element)" [required]="
                  (element.CorrectedTotalTimespanDay !== null && element.CorrectedTotalTimespanDay !== undefined) ||
                  (element.CorrectedWorkedDays !== null && element.CorrectedWorkedDays !== undefined)
                " (blur)="onBlurLeadZero(formControl)" /></mat-cell></ng-container>

          <ng-template #label>
            <mat-cell>
              {{ element.CorrectedTotalTimespanNight ? (element.CorrectedTotalTimespanNight | ticksToString) : '' }}
            </mat-cell>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="correctedWorkedDays">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.CorrectedWorkedDays' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <ng-container *matCellDef="let element">
          <ng-container *ngIf="element.CanEditCorrection && hasPermissionToSetCorrections(); else label">
            <mat-cell class="input-cell" [matTooltip]="'PresencePerMonthList.ObsoleteInfo' | translate"
              matTooltipPosition="above" [matTooltipDisabled]="element.IsUpToDate">
              <input matInput #formControl="ngModel" class="time-correction-input" type="number" min="1"
                [max]="daysInMonth$ | async" placeholder="_" [ngClass]="{
                  obsolete: !element.IsUpToDate,
                  modified: element.OriginCorrectedWorkedDays !== undefined,
                  error: formControl.invalid
                }" [ngModel]="element.CorrectedWorkedDays" (ngModelChange)="saveWorkingDaysCorrection($event, element)"
                [required]="
                  (element.CorrectedTotalTimespanNight !== null && element.CorrectedTotalTimespanNight !== undefined) ||
                  (element.CorrectedTotalTimespanDay !== null && element.CorrectedTotalTimespanDay !== undefined)
                " (blur)="onBlurLeadZero(formControl)" /></mat-cell></ng-container>

          <ng-template #label>
            <mat-cell>
              {{ element.CorrectedWorkedDays }}
            </mat-cell>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container matColumnDef="totalDaysConcludedHomeOfficeRemote">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.TotalDaysConcludedHomeOfficeRemote' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{
          element.TotalDaysConcludedHomeOfficeRemote ? element.TotalDaysConcludedHomeOfficeRemote : ''
          }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="totalDaysHomeOfficeOnDemand">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'PresencePerMonthList.TotalDaysHomeOfficeOnDemand' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.TotalDaysHomeOfficeOnDemand ? element.TotalDaysHomeOfficeOnDemand
          : '' }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button *ngIf="hasPermissionToSetCorrections()" mat-raised-button color="primary" class="submit-btn"
            tabindex="-1" [disabled]="setCorrectionEnabled(element)" (click)="submit(element)">
            {{ 'PresencePerMonthList.ApproveCorrection' | translate }}
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{
          obsolete: !row.IsUpToDate
        }"></mat-row>
    </mat-table>
  </div>
  <mat-paginator [length]="dataSource.count$ | async" [pageSize]="25" [pageSizeOptions]="[25, 50, 100]">
  </mat-paginator>
</div>